import { useFormik } from "formik";
import * as yup from 'yup';
import i18nNamespaces from "../../../../const/i18nNamespaces";
import { useTranslation } from "react-i18next";
import { makeStyles, Theme, ThemeProvider, useTheme } from "@material-ui/core";
import CustomTextField from "../../../common/CustomTextField/CustomTextField";
import CustomButton from "../../../common/Button/Button";
import useStyles from '../common/AdditionalDetailsCommonStyles';
import { classicNameResolver } from "typescript";
import { appointmentsApi } from "../../../../api/appointments/appointmentsApi";
import { AlertContext } from "../../../../contexts/AlertContext";
import { useContext, useState } from "react";
import { Loading } from "../../..";


const QuestionToMedic = ({appointmentId, onSuccess} : {appointmentId: string, onSuccess: () => void}) => {
    const commonClasses = useStyles();
    const {t: commonT} = useTranslation(i18nNamespaces.COMMON);
    const {t: errorT} = useTranslation(i18nNamespaces.ERRORS);
    const {t} = useTranslation(i18nNamespaces.APPOINTMENT_DETAILS);
    const openAlert = useContext(AlertContext);
    const [loading, setLoading] = useState(false);

    const {
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
        handleSubmit,
    } = useFormik({
        initialValues: {
            question: '',
        },
        validationSchema: yup.object({
            question: yup
                .string()
                .min(10, errorT('minCharacters', { min: 10 }))
                .max(1000, errorT('maxCharacters', { max: 1000 }))
                .required(commonT('requiredField')),
        }),
        onSubmit: async (values) => {
            try{
                setLoading(true);
                await appointmentsApi.sendQuestion(parseInt(appointmentId), values.question);
                openAlert({
                    severity: 'success',
                    message: t('questionToMedic.successMessage'),
                });
                onSuccess();
            } catch(error){
                console.error('QuestionToMedic error:', error);
                openAlert({
                    severity: 'error',
                    message: errorT('sendingQuestionError'),
                });
            } finally {
                setLoading(false);
            }
        },
    });

    return (
        <>
            <Loading loading={loading} withBackdrop />
            <h4 className={commonClasses.detailsHeader}>{t('questionToMedic.title')}</h4>
            <p>
                {t('questionToMedic.description')}
            </p>
            <form onSubmit={handleSubmit}>
                <CustomTextField
                    name={'question'}
                    value={values.question}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={values.question && touched.question && !!errors.question}
                    helperText={values.question && touched.question && errors.question}
                    multiline
                    rows={2}
                    InputProps={{
                        style: {
                            height: 'auto',
                        },                      
                    }}
                    fullWidth
                />
                <CustomButton
                    type={'submit'}
                    color={'secondary'}
                    variant={'contained'}
                    style={{ marginTop: 16 }}
                    disabled={!values.question || !!errors.question || loading}
                    fullWidth
                >
                    {t('questionToMedic.send')}
                </CustomButton>
            </form>
        </>
    );
};

export default QuestionToMedic;